import Table from "../../components/table/Table";
import {ColProps, colTypeOptions, FetchProps, FilterProps, filterTypeOptions} from "../../components/table/tableTypes";
import {
    dateDaysAgo,
    formatDate, formatDateForAmPmDisplay, formatDateNoTime,
} from "../../utils/friendlyDate";
import {Tooltip} from "antd";
import {exportToCsv} from "../../utils/exportToCsv";
import {getCampaignLog} from "../../api/getCampaignLog";
import millify from "millify";
import CampaignAnalyticsPanel from "../../components/campaignAnalyticsPanel/CampaignAnalyticsPanel";
import {useEffect, useState} from "react";
import {getShopCampaignAverage} from "../../api/shopCampaignAverage";
import useUserContext from "../../hooks/useUserContext";
import {campaignAverageProps} from "../campaigns/Campaigns";
import useAppContext from "../../hooks/useAppContext";

const CampaignLog = () => {
    const { selectedDomain } = useUserContext();
    const { data: { campaigns } } = useAppContext();
    const [campaignId, setCampaignId] = useState<number | undefined>(undefined);
    const [shopCampaignAverage, setShopCampaignAverage] = useState<campaignAverageProps | undefined>(undefined);

    const loadShopCampaignAverages = async () => {
        if(!selectedDomain) return;
        const campaignAvg = await getShopCampaignAverage(selectedDomain);
        setShopCampaignAverage(campaignAvg.data);
    }

    useEffect(() => {
        if(selectedDomain && selectedDomain !== 'vuelve.co') {
            loadShopCampaignAverages();
        }
    }, [selectedDomain]);

    const fetch = async ({ filters, selectedDomain, isCsvCall, page, pageSize }: FetchProps) => {
        const response = await getCampaignLog(selectedDomain, filters, page, pageSize);
        if(isCsvCall) {
            exportToCsv(response.data.report, `Vuelve Campaigns Log - ${selectedDomain} - ${formatDate(new Date())}`);
        } else {
            return selectedDomain ? response : [];
        }
    }

    const onCampaignClick = (row: any) => {
        setCampaignId(row.id);
    }

    const cols: ColProps[] = [
        { key: 'id', name: '', type: colTypeOptions.text, paddingLeft: 0, isPinned: true, maxWidth: 40 },
        { key: 'title', name: 'Campaign', type: colTypeOptions.text, width: 150, render: (value: number, row: any) => <Tooltip title={row.template_content}>{value}</Tooltip> },
        { key: 'createdAt', name: 'Campaign', type: colTypeOptions.date, width: 150, render: (value: string, row: any) => <Tooltip title={formatDateForAmPmDisplay(new Date(row.createdAt))}>{formatDateNoTime(new Date(value))}</Tooltip> },
        { key: 'delivered', name: 'Delivered', type: colTypeOptions.number, width: 80, isPinned: true, render: (value: number, row: any) => row.delivered },
        { key: 'read', name: 'Read', type: colTypeOptions.number, width: 80, isPinned: true, render: (value: number, row: any) => row.read },
        { key: 'clicks', name: 'Clicks', type: colTypeOptions.number, width: 80, isPinned: true, render: (value: number, row: any) => row.clicks },
        { key: 'orders', name: 'Conversions', type: colTypeOptions.number, width: 80, isPinned: true, render: (value: number, row: any) => row.orders },
        { key: 'revenue', name: 'Revenue', type: colTypeOptions.number, width: 80, isPinned: true, render: (value: number) => `$${millify(value)}` },
        { key: 'actualCost', name: 'Cost', type: colTypeOptions.number, width: 80, isPinned: true, render: (value: number) => `$${millify(value)}` },
    ];

    const filters: FilterProps[] = [
        { filterKey: 'days', name: 'date range', type: filterTypeOptions.date, min: dateDaysAgo(90), max: new Date(), from: dateDaysAgo(30), to: new Date() },
        // { filterKey: 'templates', name: 'templates', type: filterTypeOptions.textToId, options: templatesOptions, allLabel: 'All Templates', selected: 0 },
        // { filterKey: 'campaigns', name: 'campaigns', type: filterTypeOptions.textToId, options: campaignsOptions, allLabel: 'All Campaigns', selected: 0 },
        // { filterKey: 'status', name: 'status', type: filterTypeOptions.textToKey, options: STATUS_OPTIONS, allLabel: 'All Statuses', selected: 0 },
        // { filterKey: 'clientId', name: 'client ID', type: filterTypeOptions.text },
        // { filterKey: 'checkoutId', name: 'checkout ID', type: filterTypeOptions.text },
        // { filterKey: 'phone', name: 'phone', type: filterTypeOptions.text }
    ];

    return (
        <div className="reports-container">
            <Table onRowClick={onCampaignClick} title="Messages Log" fetch={fetch} cols={cols} filters={filters} showSearch={false} doneLoadingDependencies={campaigns.isLoaded} />
            <div className="campaigns-container">
                <CampaignAnalyticsPanel isOpen={!!campaignId} campaignId={campaignId} onClose={() => setCampaignId(undefined)} shopCampaignAverage={shopCampaignAverage} />
            </div>
        </div>
    );
}

export default CampaignLog;